import { dialog } from "./utility/_dialog";
import { DisclosureNav } from "./utility/_navigation";
import { toggleContent } from "./utility/_toggler";
import { observerHeader } from "./utility/_header";
import { initSharePanel } from "./utility/_share";
import { initImageCopyright } from "./utility/_image-copyright";
import { initLocationMaps } from "./utility/_location-map";
import { initLikes } from "./utility/_likes";
import "./utility/_slider";

// Prevent "function not found" error
window.initMap = () => {
    return;
};

// toggle content
dialog();
toggleContent();
initSharePanel();
initImageCopyright();
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLocationMaps, { once: true });
} else {
    initLocationMaps();
}
initLikes();
//shrink header onscroll
observerHeader;

// Initialize Menu
window.addEventListener(
    "load",
    function () {
        var menus = document.querySelectorAll("#menuMain");
        var disclosureMenus = [];

        for (var i = 0; i < menus.length; i++) {
            disclosureMenus[i] = new DisclosureNav(menus[i]);
        }
    },
    false,
);
